import UploadsList from './views/UploadList'
import UploadEdit from './views/UploadEdit'
import UploadCreate from './views/UploadCreate'

export default {
  name:"uploads",
  list:UploadsList,
  edit:UploadEdit,
  create:UploadCreate,
}